import { NosSyncTab } from "@/components/settings/NosSyncTab";

export function SettingsNosSyncPage() {
  return <NosSyncTab />;
}
